import React from 'react';
import { extent as d3ArrayExtent } from 'd3-array';
import {
  axisBottom as d3AxisBottom,
  axisLeft as d3AxisLeft,
} from 'd3-axis';
import {
  scaleLinear as d3ScaleLinear,
  scaleTime as d3ScaleTime,
} from 'd3-scale';
import { select as d3Select } from 'd3-selection';
import { line as d3Line, area as d3Area, curveCardinal, curveNatural } from 'd3-shape';
import SVGWithMargin from '../SVGWithMargin';
import './index.css';

import forestAirImg from '../../../assets/pattern/forest.png';
import officeAirImg from '../../../assets/pattern/city.png';

type Props = {
  data: any,
  height: number,
  margin: Object | number,
  selectX: (datum: any) => any,
  selectY: (datum: any) => any,
  width: number,
};

export default ({
  data,
  height,
  margin,
  selectX,
  selectY,
  width,
}: Props) => {
  const xScale = d3ScaleTime()
    .domain(d3ArrayExtent(data, selectX))
    .range([0, width]);
  const yScale = d3ScaleLinear()
    .domain(d3ArrayExtent([{value: 0.0}, {value: 3}], selectY))
    .range([height, 0]);
  const xScaleImg = yScale(2)/75*152;
  const xAxis = d3AxisBottom()
    .scale(xScale)
    .ticks(data.length / 30);
  const yAxis = d3AxisLeft()
    .scale(yScale)
    .ticks(0);

  const selectScaledX = datum => xScale(selectX(datum));
  const selectScaledY = datum => yScale(selectY(datum));

  const sparkLine = d3Line()
    // .curve(curveNatural)
    .x(selectScaledX)
    .y(selectScaledY);

  const officeLinePath = d3Line()
    .x(selectScaledX)
    .y(datum => yScale(1.8))(data);

  const linePath = sparkLine(data);

  const circlePoints = data.map(datum => ({
    x: selectScaledX(datum),
    y: selectScaledY(datum),
  }));

  return (
    <SVGWithMargin
      className="container"
      contentContainerBackgroundRectClassName="contentContainerBackgroundRect"
      contentContainerGroupClassName="contentContainer"
      height={height}
      margin={margin}
      width={width}
    >
      <g
        className="xAxis"
        ref={node => d3Select(node).call(xAxis)}
        style={{
          transform: `translateY(${height}px)`,
        }}
      />
      <g className="line">
        <path d={linePath} />
      </g>
      <g className="line office">
        <path d={officeLinePath} />
      </g>


      {/* Forest  */}
      <defs>
        <pattern id="pattern-forest" patternUnits="userSpaceOnUse" width={xScaleImg} height={yScale(1.5)} >
          <rect className='forestAir' width={width} height={yScale(1.5)} />
          <image className='forestAirImg' href={forestAirImg} xlinkHref={forestAirImg} width={xScaleImg} height={yScale(1)} />
        </pattern>
      </defs>
      <rect x="0" y={yScale(3)} width={width} height={yScale(1.5)} fill="url(#pattern-forest)" />

      {/* Office */}
      <defs>
        <pattern id="pattern-office" y={yScale(1.5)} patternUnits="userSpaceOnUse" width={xScaleImg} height={yScale(1.5)} >
          <rect className='officeAir' width={width} height={yScale(1.5)} />
          <image className='officeAirImg' href={officeAirImg} xlinkHref={officeAirImg} width={xScaleImg} height={yScale(1)}  />
        </pattern>
      </defs>
      <rect x="0" y={yScale(1.5)} width={width} height={yScale(1.5)} fill="url(#pattern-office)" />

      <g className="yAxis" ref={node => d3Select(node).call(yAxis)} />


      {/* <image className='officeAir' x="0" y={yScale(1)} width={width} height={yScale(2)} href={cityAirImg} />
        <rect className='forestAir' x="0" y={yScale(3)} width={width} height={yScale(2)} />
      <rect className='officeAir' x="0" y={yScale(1)} width={width} height={yScale(2)} /> */}
    </SVGWithMargin>
  );
};
